<button
    class="sh-button sh-action-group__item"
    ngxClipboard
    type="button"
    (cbOnSuccess)="copySuccess.next()"
    (cbOnError)="copyFailure.next()"
    [cbContent]="data"
    [disabled]="!data || disabled"
    [title]="disabledMessage"
    [container]="container"
>
    {{ label }}
</button>
